import $ from 'jquery';
import { initSearchTerms, isRangeType } from '../aktiv/aktiv-search-terms';
import {  bindSearchElements, mapToModel, mapToEvent, initRadiobox, initCheckboxes, initCityAreas, initMunicipality, initCounties, disableDropdowns, onSliderChange, onRadiobuttonChange, onDropdownChange, onCheckboxChange } from 'scripts/shared/aktiv-search-form-controls';


let translations;
const searchTerms = initSearchTerms(false, false);

const inputs = {
  county: mapToModel('county', '#aktiv-search-county-select'),
  municipality: mapToModel('municipality', '#aktiv-search-municipality-select'),
  cityArea: mapToModel('cityArea', '#aktiv-search-cityarea-select'),
  facilities: mapToModel('facilities', 'input[name="fasiliteter"]'),
  propertyType: mapToModel('propertyType', 'input[name="eiendom"]'),
  area: mapToModel('area', '#aktiv-search-area'),
  price: mapToModel('price', '#aktiv-search-price'),
  numberOfBedrooms: mapToModel('numberOfBedrooms', 'input[name="radioBedroom"]'),
};

const bindSlider = (input, model) => {
  $(input.element).on('slideStop', (e) => {
    onSliderChange(e, input, model);
  });
};

const dropdownProperties = {
  county: {
    toClear: [inputs.municipality, inputs.cityArea],
    toDisable: [inputs.cityArea],
    init: initMunicipality },
  municipality: {
    toClear: [inputs.cityArea],
    init: initCityAreas,
  },
  cityArea: {},
};

const bindDropdown = (input, model) => {
  $(input.element).on('change', (event) => {
    onDropdownChange(input, model, event, dropdownProperties, inputs, translations);
  });
};

const bindCheckboxes = (input, model) => {
  initCheckboxes(input, model);
  $(input.element).on('change', () => {
    onCheckboxChange(input, model);
  });
};

const bindRadioButtons = (input, model) => {
  initRadiobox(input, model);
  $(input.element).on('change', () => {
    onRadiobuttonChange(input, model);
  });
};

const events = {
  county: mapToEvent(inputs.county, bindDropdown),
  municipality: mapToEvent(inputs.municipality, bindDropdown),
  cityArea: mapToEvent(inputs.cityArea, bindDropdown),
  numberOfBedrooms: mapToEvent(inputs.numberOfBedrooms, bindRadioButtons),
  area: mapToEvent(inputs.area, bindSlider),
  price: mapToEvent(inputs.price, bindSlider),
  facilities: mapToEvent(inputs.facilities, bindCheckboxes),
  propertyType: mapToEvent(inputs.propertyType, bindCheckboxes),
};


const buildQueryStringFromProperties = () => {
  const queryParams = Object.keys(searchTerms).reduce((termName, qp) => {
    const searchTerm = searchTerms[termName];
    if (termName in isRangeType) {
      return [
        ...qp,
        encodeURIComponent(`${termName}Begin`) + '=' + searchTerm.begin,
        encodeURIComponent(`${termName}End`) + '=' + searchTerm.end
      ];
    }
    const allInputTypes = Object.keys(inputs);
    if (termName in allInputTypes) {
      return [
        ...qp,
        encodeURIComponent(termName) + '=' + searchTerm
      ]
    }
    return qp;
  }, [])

  return queryParams.join('&');
};

export const init = (trans) => {
  translations = trans;
  disableDropdowns([inputs.municipality, inputs.cityArea]);
  bindSearchElements(searchTerms, inputs, events);
  initCounties(searchTerms.county, inputs, searchTerms, translations);

  $('#aktiv-search-send-button').click(() => {
    window.open('http://aktiv.no/bolig-til-salgs?' + buildQueryStringFromProperties(), '_blank');
  });
};
